import { useNavigate } from "react-router";
import React, { useEffect } from "react";
import { getCaseLink, getProductData, getProductNameBy } from "@/src/services/productService";
import Grid from "@mui/material/Grid";
import LegalbirdLoader from "../../../components/ContentLoader/LegalbirdLoader";
import Layout from "../../Layouts/Layout";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createResource, queryKeys } from "@/src/services/reactQuery/reactQueryService";
import useProductParams from "../../../hooks/useProductParams";

const InitialCaseCreationPage = () => {
  const { productName } = useProductParams();
  const navigate = useNavigate();
  const productClassName = getProductNameBy("urlPartShort", productName);
  const productApiUri = getProductData(productClassName, "apiUri");

  const queryClient = useQueryClient();
  const createMutation = useMutation({
    mutationFn: createResource,
    onSuccess: (data, variables) => queryClient.setQueryData(queryKeys.item(variables.uri, data.id), data),
  });

  let isBlocked = false;
  useEffect(() => {
    if (!isBlocked) {
      isBlocked = true;
      createMutation.mutateAsync({ uri: productApiUri, data: {} }).then((product) => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.collection("/collection/cases"),
        });
        navigate(getCaseLink(product) + "/antrag", { replace: true });
      });
    }
  }, [productApiUri]);

  return (
    <Layout>
      <Grid
        container
        sx={{
          justifyContent: "center",
          marginTop: "50px",
        }}
      >
        <Grid>
          <LegalbirdLoader />
        </Grid>
      </Grid>
    </Layout>
  );
};
export default InitialCaseCreationPage;
